import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/styles';

interface StepperHeaderProps {
  activeStep: number;
  onStepChange: (step: number) => void;
}
const StepperHeader: React.FC<StepperHeaderProps> = ({ activeStep, onStepChange }) => {
  const theme: any = useTheme();
  const stepItemStyle = (active: number) => {
    return {
      display: 'flex',
      textAlign: 'center',
      flexWrap: 'wrap',
      padding: '10px',
      borderRadius: '5px',
      borderTopLeftRadius: '5px',
      borderBottomLeftRadius: '5px',
      cursor: 'pointer',
      position: 'relative',
      justifyContent: 'center',
      backgroundColor: activeStep === active ? 'primary.main' : theme?.palette?.TmId.id.toString().includes('9') ? '#3A3A42' : 'white',
      color: activeStep === active ? 'white' : 'input.font',
    };
  };

  const stepRightTriangle = (active: number) => {
    return {
      position: 'absolute',
      display: { xs: 'none', sm: 'block', md: 'block', lg: 'block' },
      width: '30px',
      height: '30px',
      top: '5px',
      right: '-12px',
      borderRadius: '5px 0',
      background:
        activeStep === active ? theme.palette?.primary.main : theme?.palette?.TmId.id.toString().includes('9') ? '#3A3A42' : '#fff',
      borderTop: '4px solid',
      borderTopColor: 'bodyGray.main',
      borderRight: '4px solid',
      borderRightColor: 'bodyGray.main',
      transform: 'rotate(45deg)',
      zIndex: 9,
    };
  };
  return (
    <Box>
      <Box className="stepContainer">
        <Grid
          container
          sx={{
            boxShadow: '3px 4px 11px 1px rgba(0, 0, 0, 0.25)',
            display: 'flex',
            alignItems: 'center',
            borderRadius: '12px',
          }}
        >
          <Grid item xs={12} sm={4} md={4} lg={4}>
            <Box
              sx={stepItemStyle(0)}
              onClick={(event) => {
                onStepChange(0);
                //    if (editMode === false || activeStep === 2) {
                //      handleSteps(event, 0, true);
                //      setActiveStep(0);
                //    } else if (editMode === true && hasUnsavedChanges) {
                //      showWarningSnackbar('Please save changes');
                //    } else {
                //      setActiveStep(0);
                //    }
              }}
            >
              <Typography sx={{ color: activeStep === 0 ? 'white' : 'input.font' }}>Step 1: Company Profile</Typography>
              <Box sx={stepRightTriangle(0)}></Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4} md={4} lg={4}>
            <Box
              sx={stepItemStyle(1)}
              onClick={(event) => {
                onStepChange(1);
                //  if ((editMode === false && saveSkipStatus === true) || activeStep === 2) {
                //    handleSteps(event, 1, true);
                //  } else if (editMode === true && hasUnsavedChanges) {
                //    showWarningSnackbar('Please save changes');
                //  } else if (editMode === true && saveSkipStatus === true) {
                //    setActiveStep(1);
                //  } else {
                //    showWarningSnackbar('Please save and continue');
                //  }
              }}
            >
              <Typography sx={{ color: activeStep === 1 ? 'white' : 'input.font' }}>Step 2: Tax,GST Settings</Typography>
              <Box sx={stepRightTriangle(1)}></Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4} md={4} lg={4} alignItems="center">
            <Box
              sx={stepItemStyle(2)}
              onClick={(event) => {
                onStepChange(2);
                //  if (editMode === false) {
                //    if (
                //      (state.formtwo.registrationType == 2 || state.formtwo.registrationType == 3 || state.formtwo.registrationType == 4) &&
                //      state.formtwo.gstin == ''
                //    ) {
                //      showWarningSnackbar('Please Provide GSTIN');
                //      handleSteps(event, 1, true);
                //    }
                //    if (activeStep !== 2 && state.formone.states !== '' && state.formone.district !== '') {
                //      handleSteps(event, 2, true);
                //    } else if (state.formone.states == '') {
                //      updateState('formone', 'states', '', true, 'State is Required');
                //    } else if (state.formone.district == '') {
                //      updateState('formone', 'district', '', true, 'District is Required');
                //    } else if (state.formone.states == '' && state.formone.district == '') {
                //      updateState('formone', 'states', '', true, 'State is Required');
                //      updateState('formone', 'district', '', true, 'District is Required');
                //    }
                //  } else if (hasUnsavedChanges) {
                //    showWarningSnackbar('Please save changes');
                //  } else if (editMode === true && saveSkipStatus === true) {
                //    setActiveStep(2);
                //  } else {
                //    showWarningSnackbar('Please save and continue');
                //  }
              }}
            >
              <Typography sx={{ color: activeStep === 2 ? 'white' : 'input.font' }}>Step 3: Advanced Settings</Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default StepperHeader;
